import { createContext } from "react";

const Alertcontext = createContext();

export default Alertcontext;